// src/analytics.js
export const GA_ID = 'G-5VJZBWFMTX';

const host = typeof window !== 'undefined' ? window.location.hostname : '';
const isDevHost =
  host === 'localhost' ||
  host === 'phenixloc-test.fnvt.net';          // dev host
const isProdHost = host === 'phenixloc.fnvt.net';

// Optional ?ga_debug=1 to force DebugView anywhere
const urlParams  = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const forceDebug = urlParams?.get('ga_debug') === '1';
const debugMode  = isDevHost || forceDebug;

// --- tiny retry helper so we don't drop early hits ---
function sendGtag(method, ...args) {
  if (window.gtag) {
    window.gtag(method, ...args);
    return;
  }
  // retry a few times while gtag loads
  let tries = 0;
  const id = setInterval(() => {
    tries++;
    if (window.gtag) {
      clearInterval(id);
      window.gtag(method, ...args);
    } else if (tries >= 20) { // ~4s total at 200ms
      clearInterval(id);
    }
  }, 200);
}

export function pageview(path) {
  // Send GA4 page_view as an EVENT so DebugView sees debug_mode
  const payload = {
    page_path: path,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
    page_referrer: typeof document !== 'undefined' ? document.referrer : undefined,
    ...(debugMode ? { debug_mode: true } : {})
  };
  sendGtag('event', 'page_view', payload);
}

export function logEvent(name, params = {}) {
  // Include debug_mode on dev so ALL your custom events appear in DebugView too
  const payload = {
    ...params,
    environment: isProdHost ? 'prod' : 'dev',
    ...(debugMode ? { debug_mode: true } : {})
  };
  sendGtag('event', name, payload);
}
